<template>
  <div class="section address-reading">
    <div v-if="loading" class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
    <div v-else>
      <div
        v-if="address && currentField"
        class="current-address"
        :class="`current-address--${page.field}`"
      >{{ currentField }}</div>
      <ErrorMessage :field="page.field" v-else />
      <ShareActions />
      <Ezoic id="102" />
      <table class="address-details" v-if="address">
        <tr v-if="address.intersection && address.intersection.displayName">
          <th>Intersection</th>
          <td>{{ address.intersection.displayName }}</td>
        </tr>
        <tr v-if="address.neighborhood">
          <th>Neighborhood</th>
          <td>{{ address.neighborhood }}</td>
        </tr>
        <tr v-if="address.addressLine">
          <th>Street Address</th>
          <td>{{ address.addressLine }}</td>
        </tr>
        <tr v-if="address.locality">
          <th>{{ labels.locality }}</th>
          <td>{{ address.locality }}</td>
        </tr>
        <tr v-if="address.adminDistrict2">
          <th>{{ labels.adminDistrict2 }}</th>
          <td>{{ address.adminDistrict2 }}</td>
        </tr>
        <tr v-if="address.adminDistrict">
          <th>{{ labels.adminDistrict }}</th>
          <td>{{ address.adminDistrict }}</td>
        </tr>
        <tr v-if="address.postalCode">
          <th>{{ labels.postalCode }}</th>
          <td>{{ address.postalCode }}</td>
        </tr>
        <tr v-if="address.countryRegion">
          <th>{{ labels.countryRegion }}</th>
          <td>{{ address.countryRegion }}</td>
        </tr>
        <tr v-if="displayCoordinates">
          <th>Coordinates</th>
          <td>{{ displayCoordinates }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ShareActions from '@/components/ShareActions.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import Ezoic from '@/components/Ezoic.vue';

export default {
  components: { ShareActions, Ezoic, ErrorMessage },
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(['address', 'loading', 'location']),
    displayCoordinates() {
      return this.$store.getters.displayCoordinates;
    },
    currentField() {
      if (!this.address || !this.page.field) {
        return null;
      }
      const { field } = this.page;
      if (field === 'coordinates') {
        return this.displayCoordinates;
      }
      if (field in this.address) {
        if (field === 'intersection') {
          return this.address[field].displayName;
        }
        return this.address[field];
      }
      return null;
    },
    labels() {
      if (this.address && this.address.countryRegion && this.address.countryRegion === 'United States') {
        return {
          countryRegion: 'Country',
          postalCode: 'ZIP Code',
          adminDistrict: 'State',
          adminDistrict2: 'County',
          locality: 'City',
        };
      }
      return {
        countryRegion: 'Country/Region',
        postalCode: 'Postal Code',
        adminDistrict: 'State/Provence',
        adminDistrict2: 'City/Region',
        locality: 'City',
      };
    },
  },
};
</script>
